import React from 'react'
import Structure from '../components/layout/Structure'

const About = () => {
  return (
    
    <Structure>
      ABOUT
    </Structure>
    
  )
}

export default About